export default __webpack_public_path__ + "static/media/RedCross.047ff797.svg";